import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import MaPageTitle from '../../common/components/MaPageTitle'
import styles from '../assets/scss/Suppliers.module.scss'

function SuppliersHeader ({
  supplierName
}: {
  readonly supplierName?: string | null
}): ReactElement {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <MaPageTitle>
        {t('suppliers.main.title')} {supplierName ? ` – ${supplierName}` : ''}
      </MaPageTitle>
      <hr />
    </div>
  )
}

export default SuppliersHeader
